import { fetchJourneyValidate } from "./sacred-journey-api";

/**
 * Browser console: await validateJourney("user@example.com")
 */
export async function validateJourney(email) {
  if (!email) {
    console.warn("[validateJourney] Usage: await validateJourney('user@example.com')");
    return null;
  }

  console.group(`[validateJourney] ${email}`);

  try {
    const report = await fetchJourneyValidate(email);
    console.log("valid:", report.valid, "summary:", report.summary);
    console.log("archetype:", report.archetype);
    console.log("karmic_gate:", report.karmic_gate);
    console.log("adhikara:", report.adhikara);
    console.log("pathway:", report.pathway);
    console.log("daily_guidance:", report.daily_guidance);
    console.log("tattva influences:", report.mapping_breakdown?.tattva_influences);
    console.log("sadhana influences:", report.mapping_breakdown?.sadhana_influences);
    console.log("override effects:", report.override_effects);
    console.log("full report:", report);
    console.groupEnd();
    return report;
  } catch (e) {
    console.error("validation failed:", e?.response?.data?.detail || e.message);
    console.groupEnd();
    return null;
  }
}

export function installJourneyValidationConsole() {
  if (typeof window !== "undefined") {
    window.validateJourney = validateJourney;
  }
}
